<template>
  <div>
    <v-card>
      <v-dialog v-model="scanUploading" persistent width="400">
        <v-card class="pa-6 text-center">
          <v-progress-linear :value="scanUploadProgress" height="10" color="primary" striped></v-progress-linear>
          <div class="mt-4">Đang tải ảnh scan: {{ scanUploadProgress }}%</div>
          <div class="mt-2 text-caption">Vui lòng đợi quá trình hoàn tất...</div>
        </v-card>
      </v-dialog>

      <div class="pa-6">
        <div class="full-width text-end mb-6 d-flex align-center justify-end">
          <v-btn color="green" outlined class="mr-4" @click="onExportExcel">
            Xuất Excel
          </v-btn>
          <v-btn color="primary" @click="triggerScanUpload">
            Tải ảnh scan phiếu trắc nghiệm
          </v-btn>
          <span class="ml-4" v-if="unrecognizedCount > 0" style="color:red;">
            {{ unrecognizedCount }} ảnh không lấy được thông tin
          </span>
          <input ref="scanUploader" type="file" class="d-none" accept="image/*" multiple @change="onScanFileChanged" />
        </div>

        <v-card outlined>
          <v-data-table
            item-key="examCode"
            :headers="headers"
            :loading="loading"
            :items="marks"
            :items-per-page="-1"
            :disable-sort="$vuetify.breakpoint.smAndDown"
            hide-default-footer
            fixed-header
          >
            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>

            <template v-slot:[`item.scanImages`]="{ item }">
              <v-btn
                v-if="item.scanImages && item.scanImages.length"
                icon
                @click="openOriginalImagePopup(item.scanImages)"
              >
                <v-icon>mdi-image</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.examCode`]="{ item }">
              {{ item.examCode || '-' }}
            </template>

            <template v-slot:[`item.studentName`]="{ item }">
              {{ item.studentName || '-' }}
            </template>

            <template v-slot:[`item.examVariantCode`]="{ item }">
              {{ item.examVariantCode || '-' }}
            </template>

            <template v-slot:[`item.studentClass`]="{ item }">
              {{ item.studentClass || '-' }}
            </template>

            <template v-slot:[`item.correctCount`]="{ item }">
              {{ item.correctCount || '-' }}
            </template>

            <template v-slot:[`item.wrongCount`]="{ item }">
              {{ item.wrongCount || '-' }}
            </template>

            <template v-slot:[`item.value`]="{ item }">
              {{ item.value || '-' }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon small color="red" @click="deleteMark(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn icon small color="blue" @click="editScanImage(item)">
                <v-icon>mdi-image-edit</v-icon>
              </v-btn>
              <v-btn icon small color="green" @click="recheckMark(item)">
                <v-icon>mdi-pencil-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>

        <v-dialog v-model="showOriginalPopup" max-width="600">
          <v-card>
            <v-toolbar flat color="primary" dark>
              <v-toolbar-title>Ảnh gốc</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="showOriginalPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-carousel hide-delimiter-background height="400">
                <v-carousel-item v-for="(img, index) in popupOriginalImages" :key="index">
                  <v-img :src="img" contain height="400"></v-img>
                </v-carousel-item>
              </v-carousel>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showManualPopup" max-width="1200">
          <v-card>
            <v-card-title class="blue darken-4 white--text">
              <v-toolbar-title>CHẤM TAY</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn dark icon @click="closeManualPopup">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text class="pa-6">
              <v-container fluid>
                <v-row>
                  <v-col cols="12" md="6" class="mb-4 d-flex flex-column align-center justify-center">
                    <div class="manual-image-wrapper elevation-2">
                      <div class="manual-image-inner" :style="{ transform: `scale(${imageZoom})` }">
                        <v-img v-if="manualItem" :src="manualMainImage" contain class="manual-image"></v-img>
                      </div>
                    </div>
                    <div class="mt-2 d-flex align-center">
                      <v-btn icon small @click="zoomOut">
                        <v-icon>mdi-magnify-minus</v-icon>
                      </v-btn>
                      <span class="mx-2 text-caption">Zoom: {{ (imageZoom * 100).toFixed(0) }}%</span>
                      <v-btn icon small @click="zoomIn">
                        <v-icon>mdi-magnify-plus</v-icon>
                      </v-btn>
                      <v-btn text small class="ml-2" @click="resetZoom">
                        Reset
                      </v-btn>
                    </div>
                  </v-col>

                  <v-col cols="12" md="6">
                    <div class="manual-form-scroll">
                      <div class="mb-4 mt-2">
                        <v-text-field label="Số báo danh" v-model="manualExamCode" hide-details outlined />
                        <v-text-field
                          class="mt-2"
                          label="Mã đề"
                          v-model="manualExamVariantCode"
                          hide-details
                          outlined
                        />
                      </div>
                      <div class="mb-4">
                        <h3 class="mb-2">Phần I</h3>
                        <div v-for="(q, idx) in manualOmr.list_p1" :key="'p1_' + idx" class="d-flex align-center mb-1">
                          <span class="mr-2 manual-label">Câu {{ p1QuestionNumber(q) }}:</span>
                          <v-select
                            :items="p1Choices"
                            dense
                            outlined
                            hide-details
                            class="manual-select-short"
                            v-model="manualOmr.list_p1[idx][p1QuestionNumber(q)]"
                          />
                        </div>
                      </div>

                      <div class="mb-4">
                        <h3 class="mb-2">Phần II</h3>
                        <div v-for="(group, gIdx) in manualOmr.list_p2" :key="'p2_group_' + gIdx" class="mb-2">
                          <div class="font-weight-medium mb-1">Câu {{ p2QuestionNumber(group) }}</div>
                          <div class="d-flex flex-wrap">
                            <div
                              v-for="(opt, oIdx) in p2Options(group)"
                              :key="'p2_' + gIdx + '_' + oIdx"
                              class="d-flex align-center mr-3 mb-1"
                            >
                              <span class="mr-1 manual-label-small">
                                {{ p2OptionLetter(opt) }}
                              </span>
                              <v-select
                                :items="p2Choices"
                                item-text="text"
                                item-value="value"
                                dense
                                outlined
                                hide-details
                                class="manual-select-xshort"
                                v-model="opt[p2OptionLetter(opt)]"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mb-2">
                        <h3 class="mb-2">Phần III</h3>
                        <div v-for="(q, idx) in manualOmr.list_p3" :key="'p3_' + idx" class="d-flex align-center mb-1">
                          <span class="mr-2 manual-label">Câu {{ p3QuestionNumber(q) }}:</span>
                          <v-text-field
                            dense
                            outlined
                            hide-details
                            class="manual-input-short"
                            v-model="manualOmr.list_p3[idx][p3QuestionNumber(q)]"
                          />
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="pa-6">
              <v-btn color="blue darken-4" text @click="closeManualPopup" outlined>Hủy</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="applyManualGrading">
                Chấm bài
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ExamMark } from '@/plugins/api'

export default {
  props: ['query', 'subject', 'exam'],
  data() {
    return {
      loading: false,
      headers: [],
      marks: [],
      scanUploading: false,
      scanUploadProgress: 0,
      unrecognizedCount: 0,
      showOriginalPopup: false,
      popupOriginalImages: [],
      showManualPopup: false,
      manualItem: null,
      manualOmr: {
        list_p1: [],
        list_p2: [],
        list_p3: []
      },
      p1Choices: ['', 'A', 'B', 'C', 'D'],
      p2Choices: [
        { text: '', value: '' },
        { text: 'Đ', value: 'T' },
        { text: 'S', value: 'F' }
      ],
      imageZoom: 1,
      manualExamCode: '',
      manualExamVariantCode: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    manualMainImage() {
      if (!this.manualItem) return ''
      const debug = this.manualItem.debugImages && this.manualItem.debugImages[0]
      const scan = this.manualItem.scanImages && this.manualItem.scanImages[0]
      return debug || scan || ''
    }
  },
  methods: {
    ...mapActions('examMark', ['fetchMarks', 'removeMark']),
    ...mapActions('examMarkOmr', ['uploadImage', 'calMore']),
    ...mapActions('examVariant', ['fetchExamVariant']),

    async refresh() {
      this.loading = true
      try {
        const rawMarks = await this.fetchMarks({
          exam: this.query.exam,
          subject: this.query.subject,
          subjectGroup: this.query.subjectGroup,
          status: 'present',
          _sort: 'examCode:ASC',
          _limit: -1
        })

        console.log('rawMarks =>', rawMarks)

        this.marks = (rawMarks && rawMarks.length ? rawMarks : []).map(m => {
          const studentObj = m && m.student ? m.student : null
          let studentName = ''
          let studentId = ''
          let studentClass = ''

          if (studentObj && studentObj.name) studentName = studentObj.name
          else if (m.studentName) studentName = m.studentName

          if (studentObj && studentObj._id) studentId = studentObj._id

          if (studentObj && studentObj.class) {
            if (studentObj.class.title) studentClass = studentObj.class.title
            else if (studentObj.class.name) studentClass = studentObj.class.name
            else if (studentObj.class.code) studentClass = studentObj.class.code
          } else if (studentObj && studentObj.data && studentObj.data.studentClass) {
            studentClass = studentObj.data.studentClass
          } else if (m.studentClass) {
            studentClass = m.studentClass
          }

          let scanImages = []
          if (Array.isArray(m.scanImages)) scanImages = m.scanImages
          else if (m.scanImages) scanImages = [m.scanImages]

          let debugImages = []
          if (Array.isArray(m.debugImages)) debugImages = m.debugImages
          else if (m.debugImages) debugImages = [m.debugImages]

          return {
            _id: m._id,
            examCode: m.examCode,
            value: m.value || 0,
            examVariantCode: m.examVariantCode,

            studentName: studentName,
            studentId: studentId,
            studentClass: studentClass,

            scanImages: scanImages,
            debugImages: debugImages,
            variantId: m.variantId,

            omrResults: m.omrResults ? m.omrResults : { list_p1: [], list_p2: [], list_p3: [] },

            correctCount: typeof m.correctCount === 'number' ? m.correctCount : 0,
            wrongCount: typeof m.wrongCount === 'number' ? m.wrongCount : 0
          }
        })
      } catch (e) {
        console.log(e)
        this.$alert.error('Lỗi load dữ liệu bảng')
      } finally {
        this.loading = false
      }
    },
    async saveMarks() {
      this.$loading.active = true
      this.loading = true
      try {
        const payloadMarks = this.marks
          .filter(function(m) {
            return m.value !== null && m.value !== undefined && m.value !== ''
          })
          .map(function(m) {
            return {
              examCode: m.examCode,
              value: m.value,
              student: m.studentId,
              scanImages: m.scanImages,
              debugImages: m.debugImages,
              correctCount: m.correctCount,
              variantId: m.variantId,
              wrongCount: m.wrongCount,
              omrResults: m.omrResults,
              examVariantCode: m.examVariantCode
            }
          })

        const res = await ExamMark.updateSubjectGrades({
          exam: this.query.exam,
          subject: this.query.subject,
          subjectGroup: this.query.subjectGroup,
          marks: payloadMarks
        })

        if (Array.isArray(res)) {
          const mapByExamCode = {}
          for (let i = 0; i < res.length; i++) {
            const r = res[i]
            if (r && r.examCode) {
              mapByExamCode[r.examCode] = r
            }
          }

          for (let i = 0; i < this.marks.length; i++) {
            const m = this.marks[i]
            const r = mapByExamCode[m.examCode]
            if (r) {
              if (!m._id && r._id) {
                m._id = r._id
              }
              if (r.variantId) {
                m.variantId = r.variantId
              }
              if (r.examVariantCode) {
                m.examVariantCode = r.examVariantCode
              }
            }
          }
        }

        this.$alert.success('Nhập điểm thành công')
      } catch (e) {
        this.$alert.error('Nhập điểm thất bại')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },

    triggerScanUpload() {
      this.$refs.scanUploader.click()
    },

    async uploadDebugImageFromBase64(debugFile) {
      if (!debugFile || !debugFile.data) return null

      const { filename = 'debug.png', mimetype = 'image/png', data } = debugFile

      const byteString = atob(data)
      const len = byteString.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = byteString.charCodeAt(i)
      }

      const blob = new Blob([bytes], { type: mimetype })
      const file = new File([blob], filename, { type: mimetype })

      const formData = new FormData()
      formData.append('files', file)

      const res = await this.uploadImage(formData)
      if (Array.isArray(res) && res.length > 0) {
        return res[0].url
      }
      return null
    },

    async onScanFileChanged(e) {
      const files = Array.from(e.target.files)
      if (!files.length) return
      this.scanUploading = true
      this.scanUploadProgress = 0
      this.unrecognizedCount = 0

      const totalFiles = files.length
      let uploadedCount = 0
      const imagesPayload = []

      for (const file of files) {
        try {
          const formData = new FormData()
          formData.append('files', file)
          const res = await this.uploadImage(formData)
          const url = res[0].url
          const key = file.name
          imagesPayload.push({ url, k: key })

          uploadedCount++
          this.scanUploadProgress = Math.round((uploadedCount / totalFiles) * 50)
        } catch (err) {
          this.$alert.error(`Lỗi upload ảnh: ${file.name}`)
        }
      }

      try {
        const result = await this.calMore({
          key: 'u!LtraS3cr3tK3y',
          images: imagesPayload,
          subjectGroup: this.query.subjectGroup,
          subject: this.query.subject,
          exam: this.query.exam
        })

        const totalResults = result.length || 1
        let processedCount = 0

        for (const r of result) {
          const payloadItem = imagesPayload.find(i => i.k === r.k)

          if (r.debug_image_file) {
            try {
              const debugUrl = await this.uploadDebugImageFromBase64(r.debug_image_file)
              if (debugUrl) {
                r.debug_image = debugUrl
              }
            } catch (err) {
              console.error('Lỗi upload debug image', err)
            }
          }

          if (payloadItem) {
            if (r.sbd) {
              this.processScanResult(r, payloadItem.url, r.debug_image)
            } else {
              this.unrecognizedCount++
            }
          }

          processedCount++
          this.scanUploadProgress = 50 + Math.round((processedCount / totalResults) * 50)
        }

        this.scanUploadProgress = 100
        await this.saveMarks()
      } catch (err) {
        console.log(err)
        this.$alert.error('Lỗi scan OMR')
      } finally {
        this.scanUploading = false
      }

      this.$refs.scanUploader.value = null
    },

    processScanResult(result, imageUrl, debugImageUrl = null) {
      let student = this.marks.find(s => s.examCode === result.sbd)
      if (!student) {
        student = {
          examCode: result.sbd,
          value: null,
          examVariantCode: null,
          studentName: '',
          studentId: '',
          studentClass: '',
          scanImages: [],
          debugImages: [],
          correctCount: 0,
          wrongCount: 0,
          omrResults: {
            list_p1: [],
            list_p2: [],
            list_p3: []
          },
          variantId: ''
        }
        this.marks.push(student)
      }

      student.examVariantCode = result.code || student.examVariantCode || null
      student.variantId = result.variantId || null

      student.scanImages = student.scanImages || []
      student.debugImages = student.debugImages || []

      if (imageUrl && !student.scanImages.includes(imageUrl)) {
        student.scanImages.push(imageUrl)
      }

      if (debugImageUrl && !student.debugImages.includes(debugImageUrl)) {
        student.debugImages.push(debugImageUrl)
      }

      if (result.student) {
        student.studentName = result.student.name || student.studentName || ''
        student.studentId = result.student._id
        const cls = result.student.currentClass || {}
        student.studentClass = cls.title || cls.name || cls.code || student.studentClass || ''
      }

      if (result.omrResults) {
        student.omrResults = JSON.parse(JSON.stringify(result.omrResults))
      }

      const calcScore = part => Object.values(part || {}).reduce((acc, v) => acc + v / 100, 0)

      student.value = calcScore(result.p1) + calcScore(result.p2) + calcScore(result.p3)

      const countQuestions = part =>
        Object.values(part || {}).reduce(
          (acc, v) => ({
            correct: acc.correct + (v > 0 ? 1 : 0),
            wrong: acc.wrong + (v === 0 ? 1 : 0)
          }),
          { correct: 0, wrong: 0 }
        )

      const p1Count = countQuestions(result.p1)
      const p2Count = countQuestions(result.p2)
      const p3Count = countQuestions(result.p3)

      student.correctCount = p1Count.correct + p2Count.correct + p3Count.correct
      student.wrongCount = p1Count.wrong + p2Count.wrong + p3Count.wrong
    },

    openOriginalImagePopup(images) {
      this.popupOriginalImages = images || []
      this.showOriginalPopup = true
    },

    async deleteMark(item) {
      if (!item) return

      this.$dialog.confirm({
        title: 'Xác nhận xoá bài kiểm tra',
        text: 'Bạn có chắc muốn xoá bài kiểm tra này?',
        okText: 'Xoá',
        cancelText: 'Hủy',
        done: async () => {
          const markId = item._id

          if (markId && markId !== '') {
            try {
              await this.removeMark(markId)
              const arr = []
              for (let i = 0; i < this.marks.length; i++) {
                if (this.marks[i]._id !== markId) {
                  arr.push(this.marks[i])
                }
              }
              this.marks = arr
              this.$alert.success('Đã xoá kết quả chấm khỏi hệ thống')
            } catch (err) {
              this.$alert.error('Xóa kết quả chấm thất bại')
            }
          } else {
            const codeToDelete = item.examCode
            if (!codeToDelete) {
              this.$alert.error('Không tìm thấy dữ liệu để xoá')
              return
            }
            const arr = []
            for (let i = 0; i < this.marks.length; i++) {
              if (this.marks[i].examCode !== codeToDelete) {
                arr.push(this.marks[i])
              }
            }
            this.marks = arr
            this.$alert.success('Đã xoá bài khỏi danh sách tạm (chưa lưu hệ thống)')
          }
        }
      })
    },
    async recheckMark(item) {
      if (!item) return
      const label = item.studentName || (item.student && item.student.name) || item.examCode || ''
      if (label) {
        this.$alert.warn(`Đang lưu lại điểm cho ${label}`)
      }
      await this.saveMarks()
    },

    editScanImage(item) {
      if (!item) return
      this.manualItem = item
      const baseOmr = item.omrResults || { list_p1: [], list_p2: [], list_p3: [] }
      this.manualOmr = JSON.parse(JSON.stringify(baseOmr))
      this.imageZoom = 1
      // set temp fields (fallback to empty string to avoid undefined)
      this.manualExamCode = item.examCode || ''
      this.manualExamVariantCode = item.examVariantCode || ''
      this.showManualPopup = true
    },

    closeManualPopup() {
      this.showManualPopup = false
      this.manualItem = null
      this.imageZoom = 1
      this.manualExamCode = ''
      this.manualExamVariantCode = ''
    },

    async applyManualGrading() {
      console.log(this.manualItem)
      if (!this.manualItem) return

      this.$dialog.confirm({
        title: 'Xác nhận chấm lại bài',
        text: 'Bạn có chắc muốn chấm lại bài đã chỉnh tay? Sau khi xác nhận điểm sẽ được tính lại và lưu vào hệ thống.',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            if (!this.manualItem) return
            // copy edited examCode / examVariantCode back to manualItem
            this.manualItem.examCode = this.manualExamCode
            this.manualItem.examVariantCode = this.manualExamVariantCode
            // try to support multiple shapes of variantId:
            const variantId = this.manualItem.variantId
            let variantParam = null
            if (this.manualItem.examVariantCode) {
              await this.saveMarks()
              this.$alert.success('Chấm tay và tính lại điểm thành công')
            } else {
              if (variantId && typeof variantId === 'object' && variantId._id) {
                variantParam = variantId._id
              } else if (variantId && typeof variantId === 'string') {
                variantParam = variantId
              }

              if (!variantParam) {
                this.$alert.error('Không tìm thấy variantId hoặc mã đề (examVariantCode), không thể chấm lại')
                return
              }

              const variant = await this.fetchExamVariant(variantParam)
              if (!variant) {
                this.$alert.error('Không tải được dữ liệu mã đề')
                return
              }

              const manual = JSON.parse(JSON.stringify(this.manualOmr))
              let scoreP1 = 0
              let scoreP2 = 0
              let scoreP3 = 0
              let correctCount = 0
              let wrongCount = 0

              const l1 = variant && variant.part1 && variant.part1.length ? variant.part1 : []
              const s1 = variant && variant.scores && variant.scores.part1 ? variant.scores.part1 : []

              for (let i = 0; i < manual.list_p1.length; i++) {
                const keys = Object.keys(manual.list_p1[i])
                const key = keys && keys[0] ? keys[0] : ''
                if (!key) continue

                const ans = manual.list_p1[i][key] ? manual.list_p1[i][key].trim() : ''
                const correct = l1[i] ? l1[i] : ''
                const point = ans === correct ? (s1[i] ? s1[i] : 0) * 100 : 0

                scoreP1 += point
                if (ans === correct) correctCount++
                else wrongCount++
              }

              let rawPart2 = variant && variant.part2 ? variant.part2 : []
              const fixedL2 = []
              for (let i = 0; i < rawPart2.length; i++) {
                fixedL2.push(rawPart2[i] === 'S' ? 'F' : 'T')
              }

              for (let gIdx = 0; gIdx < manual.list_p2.length; gIdx++) {
                const group = manual.list_p2[gIdx]
                const keys = Object.keys(group)
                const key = keys && keys[0] ? keys[0] : ''
                if (!key) continue

                const answers = group[key] ? group[key] : []
                let match = 0

                for (let i = 0; i < answers.length; i++) {
                  const opt = answers[i]
                  const optKey = Object.keys(opt)[0]
                  const userAns = opt[optKey]
                  const realAns = fixedL2[gIdx * 4 + i]

                  if (userAns && userAns === realAns) match++
                }

                correctCount += match
                wrongCount += 4 - match

                let point = 0
                if (match === 1) point = 10
                else if (match === 2) point = 25
                else if (match === 3) point = 50
                else if (match === 4) point = 100

                scoreP2 += point
              }

              const l3 = variant && variant.part3 && variant.part3.math ? variant.part3.math : []
              const s3 =
                variant && variant.scores && variant.scores.part3 && variant.scores.part3.math
                  ? variant.scores.part3.math
                  : []

              for (let i = 0; i < manual.list_p3.length; i++) {
                const keys = Object.keys(manual.list_p3[i])
                const key = keys && keys[0] ? keys[0] : ''
                if (!key) continue

                const ans = manual.list_p3[i][key] ? manual.list_p3[i][key].trim() : ''
                const correct = l3[i] ? l3[i] : ''
                const point = ans === correct ? (s3[i] ? s3[i] : 0) * 100 : 0

                scoreP3 += point
                if (ans === correct) correctCount++
                else wrongCount++
              }

              // update manualItem with the manual omr results & computed values
              this.manualItem.omrResults = JSON.parse(JSON.stringify(manual))
              this.manualItem.correctCount = correctCount
              this.manualItem.wrongCount = wrongCount
              this.manualItem.value = (scoreP1 + scoreP2 + scoreP3) / 100

              // close popup and reset zoom
              this.showManualPopup = false
              this.imageZoom = 1

              // save to server
              await this.saveMarks()
              this.$alert.success('Chấm tay và tính lại điểm thành công')
            }
          } catch (err) {
            console.error(err)
            this.$alert.error('Lỗi khi chấm lại bài')
          }
        }
      })
    },
    zoomIn() {
      if (this.imageZoom < 3) {
        this.imageZoom += 0.25
      }
    },

    zoomOut() {
      if (this.imageZoom > 0.5) {
        this.imageZoom -= 0.25
      }
    },

    resetZoom() {
      this.imageZoom = 1
    },

    p1QuestionNumber(obj) {
      return Object.keys(obj || {})[0]
    },

    p2QuestionNumber(group) {
      return Object.keys(group || {})[0]
    },

    p2Options(group) {
      const key = this.p2QuestionNumber(group)
      const arr = group && group[key]
      return Array.isArray(arr) ? arr : []
    },

    p2OptionLetter(opt) {
      return Object.keys(opt || {})[0]
    },

    p3QuestionNumber(obj) {
      return Object.keys(obj || {})[0]
    },
    async onExportExcel() {
      if (!this.marks || !Array.isArray(this.marks) || this.marks.length === 0) {
        this.$alert.error('Không có dữ liệu để xuất Excel')
        return
      }

      const headers = [
        { text: 'STT', value: 'stt' },
        { text: 'Họ tên', value: 'studentName' },
        { text: 'Số báo danh', value: 'examCode' },
        { text: 'Phòng thi', value: 'examRoom' },
        { text: 'Ghi chú', value: 'note' },
        { text: 'Lớp', value: 'studentClass' },
        { text: 'Ngày sinh', value: 'dob' },
        { text: 'Giới tính', value: 'gender' },
        { text: 'Mã đề thi', value: 'examVariantCode' },
        { text: 'Đúng', value: 'correctCount' },
        { text: 'Sai', value: 'wrongCount' },
        { text: 'Điểm', value: 'value' }
      ]

      for (let i = 1; i <= 40; i++) {
        headers.push({ text: 'P1-' + i, value: 'p1_' + i })
      }

      const p2Key = ['a', 'b', 'c', 'd']
      for (let i = 1; i <= 8; i++) {
        for (let k = 0; k < 4; k++) {
          headers.push({ text: 'P2-' + i + p2Key[k], value: 'p2_' + i + p2Key[k] })
        }
      }

      for (let i = 1; i <= 6; i++) {
        headers.push({ text: 'P3-' + i, value: 'p3_' + i })
      }

      const data = []

      for (let idx = 0; idx < this.marks.length; idx++) {
        const m = this.marks[idx]
        console.log(m)
        const row = {
          stt: idx + 1,
          studentName: m && m.studentName ? m.studentName : '',
          examCode: m && m.examCode ? m.examCode : '',
          examRoom: m && m.room ? m.room : '',
          note: m && m.note ? m.note : '',
          studentClass: m && m.studentClass ? m.studentClass : '',
          dob: m && m.dob ? m.dob : '',
          gender: m && m.gender ? m.gender : '',
          examVariantCode: m && m.examVariantCode ? m.examVariantCode : '',
          correctCount: m && m.correctCount ? m.correctCount : 0,
          wrongCount: m && m.wrongCount ? m.wrongCount : 0,
          value: m && m.value ? m.value : 0
        }

        const omr =
          m && m.omrResults ? JSON.parse(JSON.stringify(m.omrResults)) : { list_p1: [], list_p2: [], list_p3: [] }

        for (let i = 1; i <= 40; i++) {
          let val = ''
          if (omr.list_p1 && omr.list_p1[i - 1] && omr.list_p1[i - 1][i]) {
            val = omr.list_p1[i - 1][i]
          }
          row['p1_' + i] = val
        }

        for (let g = 1; g <= 8; g++) {
          let arr = omr.list_p2 && omr.list_p2[g - 1] && omr.list_p2[g - 1][g] ? omr.list_p2[g - 1][g] : []

          const convert = v => (v === 'T' ? 'Đ' : v === 'F' ? 'S' : '')

          row['p2_' + g + 'a'] = arr[0] && arr[0].a ? convert(arr[0].a) : ''
          row['p2_' + g + 'b'] = arr[1] && arr[1].b ? convert(arr[1].b) : ''
          row['p2_' + g + 'c'] = arr[2] && arr[2].c ? convert(arr[2].c) : ''
          row['p2_' + g + 'd'] = arr[3] && arr[3].d ? convert(arr[3].d) : ''
        }

        for (let i = 1; i <= 6; i++) {
          let val = ''
          if (omr.list_p3 && omr.list_p3[i - 1] && omr.list_p3[i - 1][i]) {
            val = omr.list_p3[i - 1][i]
          }
          row['p3_' + i] = val
        }

        data.push(row)
      }

      this.$utils.exportExcel(data, headers, 'OMR_Export_' + Date.now())
      this.$alert.success('Xuất Excel chấm bài tự động thành công')
    }
  },

  watch: {
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.refresh()
      }
    }
  },

  created() {
    this.headers = [
      { text: 'STT', value: 'index' },
      { text: 'Ảnh gốc', value: 'scanImages' },
      { text: 'SBD', value: 'examCode' },
      { text: 'Học sinh', value: 'studentName' },
      { text: 'Mã đề', value: 'examVariantCode' },
      { text: 'Lớp', value: 'studentClass' },
      { text: 'Số câu đúng', value: 'correctCount' },
      { text: 'Số câu sai', value: 'wrongCount' },
      { text: 'Điểm', value: 'value' },
      { text: 'Thao tác', value: 'actions' }
    ]
  }
}
</script>

<style scoped>
.manual-image-wrapper {
  max-height: 450px;
  width: 100%;
  overflow: auto;
  background: #000;
}
.manual-image-inner {
  transform-origin: top left;
}
.manual-image {
  max-height: 450px;
  width: 100%;
}
.manual-form-scroll {
  max-height: 450px;
  overflow-y: auto;
  padding-right: 8px;
}
.manual-label {
  width: 80px;
  min-width: 80px;
}
.manual-label-small {
  width: 18px;
  min-width: 18px;
  text-align: center;
}
.manual-select-short {
  max-width: 120px;
}
.manual-select-xshort {
  max-width: 80px;
}
.manual-input-short {
  max-width: 150px;
}
</style>
